import type {MessageDescriptor} from 'react-intl';

/**
 * A forecast model's display name.
 *
 * Most names are proper nouns that read the same in every language (GFS,
 * ECMWF HRES, AROME, MET Norway) and stay plain strings. A name that carries
 * a generic word as well as a brand ("SmartMixin multi-model", "Weatherflow
 * Forecast") is a message: the brand stays verbatim, the generic word is
 * translated (FE #307).
 */
export type ForecastModelTitle = string | MessageDescriptor;

/** The name to print, in the user's language. */
export const formatForecastModelTitle = (
  title: ForecastModelTitle,
  formatMessage: (descriptor: MessageDescriptor) => string,
): string => (typeof title === 'string' ? title : formatMessage(title));
